import React from "react";

const Kotlin_Variables = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Variables</h1>
      <p>Content for Kotlin Variables goes here.</p>
    </div>
  );
};

export default Kotlin_Variables;
